import { useCallback, useRef } from "react";
import { useDispatch } from "react-redux";
import { createLoginLink } from "app/containers/PaymentConnection/slice";

// The login URL is single-use: never store or log it. A ref, not state, guards
// each key's request so a double-click in the same tick is still caught, while
// a different button (Refund vs View Dispute) can start its own.
export const useOpenStripeDashboard = (setToast) => {
  const dispatch = useDispatch();
  const pendingKeys = useRef(new Set());

  return useCallback(
    (key = "default") => {
      if (pendingKeys.current.has(key)) return;
      pendingKeys.current.add(key);
      dispatch(createLoginLink())
        .unwrap()
        .then((url) => {
          if (url) window.open(url, "_blank", "noopener,noreferrer");
        })
        .catch((err) =>
          setToast({
            show: true,
            message: err?.message || "Couldn't open Stripe dashboard",
            variant: "error",
          })
        )
        .finally(() => {
          pendingKeys.current.delete(key);
        });
    },
    [dispatch, setToast]
  );
};
